/* eslint-disable no-unused-vars */
/* eslint-disable prefer-const */
/* eslint-disable no-param-reassign */
import TableRow from '@tiptap/extension-table-row';

export default TableRow.extend({
  addNodeView() {
    return ({ node }) => {
      // Create a <tr> element for the table row
      const rowElement = document.createElement('tr');
      rowElement.style.position = 'relative';
      rowElement.className = 'custom-table-row'; // Add a custom class for styling

      // Apply styles for row height and background color
      rowElement.style.minHeight = '31px'; // Set a fixed height for the row
      rowElement.style.backgroundColor = 'white';
      rowElement.style.width = '100%';
      // Create a <style> element to apply CSS to the row cells
      const style = document.createElement('style');
      style.textContent = `
        .custom-table-row td,
        .custom-table-row th {
          border: 0.5px solid #84AFEF; 
          border-radius: inherit;
          
        }
        th p, td p {
          margin: 0;
          padding: 0;
        }
      `;
      document.head.appendChild(style);

      // Return the node view with the custom row element
      return {
        dom: rowElement,
        contentDOM: rowElement, // Use the same element for contentDOM
      };
    };
  },
});
